import React, { ReactNode } from 'react';
import { Select } from '../../../../packages/pareto-style/select/Select';
import * as S from '../../common.styles';
import { TEXT_FIELD_TEST_IDS } from '../text-fields.constants';
import { RowTextFieldWithMenuDropdown, selectStyles } from './text-field-menu-dropdown.styles';

const defaultProps = {
    inputId: TEXT_FIELD_TEST_IDS.MENU_DROPDOWN,
    error: null,
};

export interface TextFieldMenuDropdownProps {
    value: any;
    label: ReactNode;
    isMulti?: boolean;
    options: any[];
    placeholder?: string;
    inputId?: string;
    isSearchable?: boolean;
    testIds?: Record<string, string>;
    openMenuOnFocus?: boolean;
    onChange?: (e: any) => void;
    error?: string;
    components?: any;
    isLoading?: boolean;
    isDisabled?: boolean;
}

export const TextFieldMenuDropdown = ({
    label,
    inputId,
    error,
    isDisabled,
    ...props
}:TextFieldMenuDropdownProps) => (
    <S.Wrapper disabled={isDisabled}>
        <RowTextFieldWithMenuDropdown error={error}>
            <Select
                inputId={inputId}
                styles={selectStyles}
                isDisabled={isDisabled}
                {...props}
            />
            <S.LabelWithBorder>{label}</S.LabelWithBorder>
        </RowTextFieldWithMenuDropdown>
        <S.ErrorLabel>{error}</S.ErrorLabel>
    </S.Wrapper>
);

TextFieldMenuDropdown.defaultProps = defaultProps;
